import type { GridValueFormatterParams } from "@mui/x-data-grid";

const replaceUnderscore = () => ({ value = '' }: GridValueFormatterParams) =>
    value.replace(/_/g, ' ');

export default replaceUnderscore;
